module.exports = __webpack_public_path__ + "media/images/home/BG-688f6916910dac35b7c3c258ee85b06a.svg";